import { Box, Button, Container, MobileStepper, Step, StepLabel, Stepper } from "@mui/material"
import ApiButton from "components/Button"
import React, { useContext, useState } from "react"
import { useStyles } from "./useStyles"

import { faFileExcel, faFileImport, faSearch, faSitemap } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useApi } from "auth/useApi3"
import clsx from "clsx"
import ApiResult from "components/ApiResultFeedback"
import { Formik } from "formik"
import { apiEndpoints } from "generated/apiEndpoints"
import { CompleteArea } from "./CompleteArea"
import { ImportFuelContext } from "./ImportFuelFormStateProvider"
import { PreviewImportArea } from "./PreviewImportArea"
import { SelectFields } from "./SelectFieldsArea"
import { SuccessArea } from "./SuccessArea"
import { UploadExcelToJson } from "./UploadExcelArea"
import { validationFile, validationRegnr } from "./validationSchema"
import { useTranslation } from "react-i18next"
function getSteps(t) {
  return [
    t("vehicleregistry.upload_excel", "Upload excel"),
    t("vehicleregistry.enter_identification", "Enter identification"),
    t("global.preview", "Preview"),
    t("global.buttons.complete", "Complete")
  ]
}

function getStepContent(stepIndex, setFieldValue, touched, errors, values, validateResult, resetForm) {
  switch (stepIndex) {
    case 0:
      return (
        <UploadExcelToJson
          setFieldValue={setFieldValue}
          touched={touched}
          errors={errors}
          values={values}
          resetForm={resetForm}
        />
      )
    case 1:
      return <SelectFields setFieldValue={setFieldValue} touched={touched} errors={errors} values={values} />
    case 2:
      return <PreviewImportArea />
    case 3:
      return <CompleteArea validateResult={validateResult} />

    default:
      return "Unknown"
  }
}

function StepIcon(props) {
  const classes = useStyles()
  const { active, completed } = props

  const icons = {
    1: <FontAwesomeIcon icon={faFileExcel} />,
    2: <FontAwesomeIcon icon={faSitemap} />,
    3: <FontAwesomeIcon icon={faSearch} />,
    4: <FontAwesomeIcon icon={faFileImport} />
  }

  return (
    <div
      className={clsx(classes.icon, {
        [classes.active]: active,
        [classes.completed]: completed
      })}>
      {icons[String(props.icon)]}
    </div>
  )
}
export const ImportFormWizard = () => {
  const importDataContext = useContext(ImportFuelContext)
  const { t } = useTranslation()
  const steps = getSteps(t)
  const classes = useStyles()
  const [activeStep, setActiveStep] = useState(0)

  const handleNext = () => {
    if (activeStep === 2) {
      validateForm()
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }
  const [validateResult, validateFuncs] = useApi()

  const validateForm = () => {
    const rows = importDataContext.getDataToImport()
    validateFuncs.post(apiEndpoints.vehicleregistryadmin.validateimportrefueldata, {
      Rows: rows
    })
  }

  const [submitResult, submitFuncs] = useApi()
  const submitForm = () => {
    const rows = importDataContext.getDataToImport()

    submitFuncs.post(apiEndpoints.vehicleregistryadmin.importrefueldata, {
      Rows: rows
    })
    setActiveStep(activeStep + 1)
  }

  const schemaArray = [validationFile, validationRegnr]
  const [formData, setFormData] = useState({
    excelFile: "",
    regnr: "",
    propellant: "",
    odometer: "",
    fuelVolume: "",
    transactionTime: ""
  })
  const feedback = {
    errorTitle: t("vehicleregistry.could_not_import_tank_file", "Could not import tank file")
  }

  return (
    <Formik
      initialValues={formData}
      onSubmit={() => {
        handleNext()
      }}
      validationSchema={schemaArray[activeStep]}>
      {({ values, errors, touched, handleSubmit, setFieldValue, resetForm }) => (
        <form onSubmit={handleSubmit} noValidate>
          {submitResult && submitResult.status === 3 && (
            <ApiResult result={submitResult} feedback={feedback} />
          )}
          <Container>
            {activeStep !== steps.length && (
              <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel StepIconComponent={StepIcon}>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            )}
          </Container>
          <div>
            {activeStep === steps.length ? (
              <div>
                <SuccessArea submitResult={submitResult} />
              </div>
            ) : (
              <Box marginTop={3}>
                {getStepContent(
                  activeStep,
                  setFieldValue,
                  touched,
                  errors,
                  values,
                  validateResult,
                  resetForm
                )}
              </Box>
            )}
          </div>

          {activeStep !== steps.length && (
            <MobileStepper
              variant="progress"
              steps={4}
              position="static"
              activeStep={activeStep}
              className={classes.mobileStepper}
              nextButton={
                activeStep === 4 - 1 ? (
                  <ApiButton
                    color="primary"
                    variant="contained"
                    onClick={submitForm}
                    feedback={{
                      errorTitle: t(
                        "vehicleregistry.could_not_submit_the_sample",
                        "Could not submit the sample"
                      )
                    }}>
                    {t("vehicleregistry.complete_import", "Complete import")}
                  </ApiButton>
                ) : (
                  <Button color="primary" variant="contained" type="submit">
                    {t("global.buttons.next", "Next")}
                  </Button>
                )
              }
              backButton={
                activeStep !== 0 ? (
                  <Button onClick={handleBack} color="inherit">
                    {t("global.buttons.previous", "Previous")}
                  </Button>
                ) : (
                  <div></div>
                )
              }
            />
          )}
        </form>
      )}
    </Formik>
  )
}
